export default __webpack_public_path__ + "static/media/airbnb-logo.e4424517.png";